import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
import moment from "moment";
import Flatpickr from "react-flatpickr";
import "flatpickr/dist/flatpickr.css";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import "flatpickr/dist/plugins/monthSelect/style.css";
export default function PaymentReport() {
  const [filterValues, setFilterValues] = useState({
    month: new Date(),
  });
  const [data, setData] = useState([]);
  const [errors, setErrors] = useState({});
  const [lists, setLists] = useState([]);
  const userId = localStorage.getItem("userId");
  const [staff, setStaff] = useState([]);

  const headerconfig = {
    headers: { Authorization: "Bearer " + localStorage.getItem("userToken") },
  };

  const handleclear = () => {
    GetData();

    setFilterValues({
      month: new Date(),
    });
  };
  const handleSearch = () => {
    GetData();
  };

  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilterValues({
      ...filterValues,
      [name]: value,
    });
  };

  const handleSubmit = (e) => {
    if (e) e.preventDefault();
    GetData();
  };

  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETATTENDANCEREPORT +
          "?userId=" +
          userId +
          "&month=" +
          moment(filterValues.month).format("YYYY-MM"),
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data);
        setData(response.data.data);
      });
  };

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  useEffect(() => {
    GetData();
  }, []);

  return (
    <div id="layout-wrapper">
      <LayoutHeader />
      <LayoutSideBar />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-0">Attendance Report</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off">
                <div className="row">
                  <div className="col-lg-3">
                    <label>Month</label>
                    <div className="input-group">
                      <Flatpickr
                        value={filterValues.month}
                        className="form-control"
                        options={{
                          dateFormat: "Y-m",
                          maxDate: new Date(),
                          plugins: [
                            new (require("flatpickr/dist/plugins/monthSelect"))(
                              {
                                shorthand: true,
                                dateFormat: "M-Y",

                                theme: "light",
                              }
                            ),
                          ],
                        }}
                        onChange={(date) =>
                          setFilterValues({ ...filterValues, month: date[0] })
                        }
                      />

                      <div className="input-group-text bg-primary border-primary text-white">
                        <i className="ri-calendar-2-line" />
                      </div>
                    </div>
                  </div>

                  <div className="col-md-3">
                    <div className="hstack gap-2 justify-content-middle mb-3 mt-4">
                      <button
                        type="button"
                        className="btn btn-primary w-100"
                        onClick={handleSearch}
                      >
                        Search
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={handleclear}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>Staff</th>
                            <th>Month</th>
                            <th>Total Working Days</th>
                            <th>Attended Days</th>
                            <th>Total Hours</th>
                            <th>Total Worked Hours</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.length > 0 ? (
                            lists.map((v, index) => (
                              <tr key={index}>
                                <td>{v.staffName}</td>
                                <td>{moment(v.month).format("MMM-YYYY")}</td>
                                <td>{v.totalWorkingDays}</td>
                                <td>{v.attendedDays}</td>
                                <td>
                                  {Math.floor(v.totalHours)}h :
                                  {Math.round((v.totalHours % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}
                                  m
                                </td>
                                <td>
                                  {Math.floor(v.totalWorkedHours)}h :
                                  {Math.round((v.totalWorkedHours % 1) * 60)
                                    .toString()
                                    .padStart(2, "0")}
                                  m
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="10" className="text-center">
                                No Data Available
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
